import globals from "../../../components/common/globals";
// import { info } from "autoprefixer";

export default {
  name: "vx-interactive-map",
  data() {
    return {
      globals,
      dataIndex: -1,
      num: 0,
      showBtn: true,
      projectImage: "",
      locationName: "",
      stateName: "",
      projectType: "",
      locationDescription: "",
      projectIndex: "",
    };
  },
  props: {
    mapData: {
      type: Object,
      default() {
        return {
          mapActive: [
            {
              id: "arizona",
              transform: "translate(175.577 438.594)",
              loc: [
                {
                  pid: "state",
                  path:
                    "M196.856,85.164,72.114,61.6,69.9,77.17V89.926l-11.347,2.83-4.9-7.377H46l2.334,27.913-4.762,7.028,9.671,24.237-12.219,9.778v9.55l-9.523,9.59v8.343l4.8,2.414v8.826l-9.966,2.495-1.677,3.313,94.857,56.925,56.12,9.389L196.882,85.245h0Z",
                  transform: "translate(-24.659 -61.597)",
                },
                {
                  pid: "tree",
                  imgPath:
                    "https://d3f8e2yx8gxglk.cloudfront.net/adaptivemedia/rendition?id=38e944559d25de9487d8d5d2cf095f7114e4c31a",
                  locName: "Apache-Sitgreaves National Forest",
                  state: "Arizona",
                  projType: "Wildfire Recovery, Watershed Restoration",
                  locDescription:
                    "Ponderosa pine habitat could not reestablish after intense fires. Replanting helps restore the landscape and provide habitat for area wildlife including the northern goshawk.",
                  path:
                    "M53.212,116.359a.829.829,0,0,0,0-.283l-2.81.415a.887.887,0,0,1-.717-1.529l2.169-1.887a.433.433,0,0,0,.132-.132v-4.4l-7.734,2.265a2.735,2.735,0,0,1-3.376-1.887,2.7,2.7,0,0,1,1.018-2.963l6.545-4.756a2.7,2.7,0,0,0,1.037-1.6l.208-.887-3.64,1.132a2.622,2.622,0,0,1-3.32-1.717,2.661,2.661,0,0,1,1.019-3l5.262-3.623A2.718,2.718,0,0,0,50.1,89.845l.377-1.887-1.49.509a2.661,2.661,0,0,1-2.32-4.737l2.867-1.887A2.642,2.642,0,0,0,50.7,80.069l.943-5.662a2.641,2.641,0,0,1,5.225,0l.943,5.662a2.642,2.642,0,0,0,1.169,1.774l2.848,1.887a2.68,2.68,0,0,1,.773,3.68,2.64,2.64,0,0,1-3.074,1.057l-1.49-.509.377,1.887a2.586,2.586,0,0,0,1.094,1.661l5.263,3.642a2.661,2.661,0,0,1-2.32,4.718l-3.64-1.151.208.887a2.812,2.812,0,0,0,1.056,1.6l6.545,4.756a2.737,2.737,0,0,1-1.547,4.944,2.907,2.907,0,0,1-.811-.113l-7.733-2.246v4.4l.113.132,2.169,1.887a.868.868,0,0,1,0,1.245.83.83,0,0,1-.641.3h-.132l-2.81-.434a.89.89,0,0,0-.113.283.943.943,0,0,1-1.113.774.981.981,0,0,1-.773-.774Z",
                  transform: "translate(73.918 2.995)",
                  mapIndex: "1",
                },
              ],
            },
            {
              id: "arkansas",
              transform: "translate(727.056 495.975)",
              loc: [
                {
                  pid: "state",
                  path:
                    "M195.72,157.364v-.429l14.432-21.649V120.653l9.617-7.189V96.9l4.668-7.015-2.119-6.371-5.084-5.084,2.173-8.772H201.97l-4.775,2.4H163.327L102.11,74.431v3.581l2.414,21.461,2.388,11.9,2.374,54.229h12.072v19.194h49.092l26.933-2.159Z",
                  transform: "translate(-102.11 -69.656)",
                },
                {
                  pid: "tree",
                  imgPath:
                    "https://d3f8e2yx8gxglk.cloudfront.net/adaptivemedia/rendition?id=36557850a2fa3ab11a9af8d5986661b2bfab58e2",
                  locName: "Ouachita National Forest",
                  state: "Arkansas",
                  projType: "Habitat Restoration",
                  locDescription:
                    "Areas of this forest are unable to regenerate naturally. Reestablishing cover of native shortleaf pine can help maintain forest health and provide habitat for wildlife.",
                  path:
                    "M117.882,118.547a.622.622,0,0,0,0-.284l-2.81.416a.868.868,0,0,1-1-.737.833.833,0,0,1,.283-.794l2.169-1.891a.435.435,0,0,0,.132-.132v-4.406l-7.734,2.25a2.743,2.743,0,0,1-2.376-4.841l6.545-4.766a2.743,2.743,0,0,0,1.056-1.608l.207-.908L110.715,102a2.658,2.658,0,0,1-3.339-1.721,2.708,2.708,0,0,1,1.037-3.007l5.244-3.631a2.686,2.686,0,0,0,1.094-1.683l.377-1.891-1.49.511a2.666,2.666,0,0,1-2.3-4.747l2.867-1.891a2.686,2.686,0,0,0,1.169-1.778l.943-5.673a2.658,2.658,0,0,1,5.225,0l.943,5.673a2.667,2.667,0,0,0,1.151,1.778L126.5,85.83a2.666,2.666,0,0,1-2.3,4.747l-1.49-.511.377,1.891a2.648,2.648,0,0,0,1.094,1.664l5.244,3.631a2.647,2.647,0,0,1-2.3,4.728l-3.64-1.135.207.889a2.818,2.818,0,0,0,1.056,1.608l6.545,4.766a2.743,2.743,0,0,1-1.547,4.955,3.03,3.03,0,0,1-.83-.113l-7.733-2.269v4.406a.435.435,0,0,0,.132.132l2.169,1.891a.891.891,0,0,1,0,1.248.867.867,0,0,1-.641.3h-.151l-2.811-.416a1.662,1.662,0,0,0-.094.284.943.943,0,0,1-1.113.775.963.963,0,0,1-.773-.775Z",
                  transform: "translate(-81.747 -41.105)",
                  mapIndex: "2",
                },
              ],
            },
            {
              id: "california",
              transform: "translate(0 208.52)",
              loc: [
                {
                  pid: "state",
                  path:
                    "M86.286,152.565l26.236-88.231L19.06,29.285,16.632,54.609,6.908,71.59,0,76.231V89.51L4.8,94.3v15.385L0,114.512V137.6l9.59,11.978v16.592l6.183,4.118,7.78-2.6,2.884,8.718-3,9.081L16.1,180.531l-1.623,3.313v15.948l12.179,9.751-2.924,8.826H18.778L16.968,222,35.92,267.1l5.124,12.742-5.03,5.017v6.183l9.067,9.081,12.072,4.869,9.912,7.444,2.294,9.107H83.081l5.687,2.87v7.3l7.042,4.829L110.363,361l2.307,20.669,63.645,9.389,8.437-2.119v-5.526l-4.788-2.388V370.178l9.59-9.59v-9.671l11.763-9.389L192.1,318.458Z",
                  transform: "translate(0 -29.285)",
                },
                {
                  pid: "tree",
                  imgPath:
                    "https://d3f8e2yx8gxglk.cloudfront.net/adaptivemedia/rendition?id=df2b94d1c76cbfcf457aa81e086c07547eee0d1f",
                  locName: "Klamath National Forest",
                  state: "California",
                  projType: "Wildfire Recovery, Wildlife Habitat Restoration",
                  locDescription:
                    "Wildfires left charred landscape with little hope of natural regeneration. Reforestation can reestablish critical habitat for threatened and endangered species and prevent erosion.",
                  path:
                    "M17.423,75.229a1.664,1.664,0,0,0-.094-.283l-2.81.434a.887.887,0,0,1-1-.755.85.85,0,0,1,.283-.793l2.169-1.888.113-.132v-4.4L8.351,69.565a2.735,2.735,0,0,1-3.376-1.888,2.777,2.777,0,0,1,1.019-2.964l6.545-4.588a2.757,2.757,0,0,0,1.056-1.6l.207-.887-3.64,1.152a2.678,2.678,0,0,1-3.339-1.737A2.626,2.626,0,0,1,7.86,54.063L13.1,50.419A2.587,2.587,0,0,0,14.2,48.757l.377-1.888-1.49.51a2.672,2.672,0,0,1-2.32-4.815l2.867-1.888a2.7,2.7,0,0,0,1.151-1.794l.943-5.664a2.659,2.659,0,0,1,5.244,0l.943,5.664a2.625,2.625,0,0,0,1.151,1.794l2.867,1.888a2.643,2.643,0,0,1-2.3,4.72l-1.49-.491.377,1.888a2.681,2.681,0,0,0,1.094,1.68l5.244,3.625a2.662,2.662,0,0,1-2.3,4.72l-3.64-1.152.207.906a2.719,2.719,0,0,0,1.056,1.586L30.7,64.807a2.738,2.738,0,0,1-1.528,4.947,3.031,3.031,0,0,1-.83-.113l-7.733-2.247v4.4l.132.132,2.169,1.888a.907.907,0,0,1,0,1.265,1.018,1.018,0,0,1-.641.3H22.12l-2.81-.434a1.663,1.663,0,0,0,0,.283.962.962,0,0,1-1.886,0Z",
                  transform: "translate(29.835 -18.774)",
                  mapIndex: "3",
                },
              ],
            },
            {
              id: "colorado",
              transform: "translate(350.51 332.939)",
              loc: [
                {
                  pid: "state",
                  path:
                    "M236.2,63.311l-46.946-4.681-55.168-4.8L68.032,46.759l-3.7,25.19-15.1,102.02L206.28,190.614h25.2l4.721-97.2Z",
                  transform: "translate(-49.227 -46.759)",
                },
                {
                  pid: "tree",
                  imgPath:
                    "https://d3f8e2yx8gxglk.cloudfront.net/adaptivemedia/rendition?id=45be495c1d437d7a6df3f099ee42cbb0163cb6e4",
                  locName: "Pike National Forest",
                  state: "Colorado",
                  projType: "Fire Rehabilitation",
                  locDescription:
                    "After wildfires over the last 15 years, reforestation can improve the health of the watershed that provides drinking water to urban areas and provide habitat for endangered species.",
                  path:
                    "M68.164,98.658a.636.636,0,0,0-.113-.282l-2.792.414a.865.865,0,0,1-.717-1.523l2.169-1.88.113-.132V90.874l-7.734,2.238a2.708,2.708,0,0,1-2.358-4.795l6.545-4.738a2.8,2.8,0,0,0,1.056-1.6l.189-.9L60.9,82.225a2.652,2.652,0,0,1-2.32-4.7l5.263-3.61a2.669,2.669,0,0,0,1.094-1.673l.377-1.88-1.49.508a2.68,2.68,0,0,1-3.357-1.692,2.628,2.628,0,0,1,1.056-3.027l2.848-1.88A2.632,2.632,0,0,0,65.542,62.5l.943-5.641a2.642,2.642,0,0,1,5.225,0l.943,5.641a2.632,2.632,0,0,0,1.169,1.768l2.867,1.88a2.646,2.646,0,0,1,.754,3.76,2.683,2.683,0,0,1-3.075,1.053l-1.49-.508.377,1.88A2.707,2.707,0,0,0,74.35,73.99l5.263,3.61a2.681,2.681,0,0,1-2.3,4.776l-3.64-1.128.207.884a2.688,2.688,0,0,0,1.037,1.6l6.545,4.738a2.725,2.725,0,0,1-1.547,4.926,3.008,3.008,0,0,1-.811-.113L71.37,91.025v4.381l.113.132,2.169,1.88a.863.863,0,0,1,0,1.241.907.907,0,0,1-.66.3H72.86l-2.81-.414a.826.826,0,0,0-.094.282.962.962,0,0,1-1.113.771.941.941,0,0,1-.773-.771Z",
                  transform: "translate(-10.212 1.312)",
                  mapIndex: "4",
                },
              ],
            },
            {
              id: "florida",
              transform: "translate(926.723 636.738)",
              loc: [
                {
                  pid: "state",
                  path:
                    "M134.189,118.67l2.253,5.982,28.1-4.668,7.485,2.508,17.169,2.414,9.644,16.914,8.41,2.106,19.181-19.154,15.331,2.562,17.075,14.62,19.6,12.233v20.227l-4.641,6.975,1.77,5.365,3.809-1.918h8.222l2.87,5.727v14.3L297.171,216h7.471l2.481,9.979,4.788,2.388,4.748,16.592,11.683,2.334,12.072,14.459,6.586,2.2,13.507-2.253,4.386-8.772-2.374-47.348-4.574-6.921L333.8,164.878,331.415,150.5,309.7,121.567l-9.389-30.34H287.769L285.381,103.3H262.834l-55.664,2.414-7.149-7.2-69.869,9.3Z",
                  transform: "translate(-130.151 -78.397)",
                },
                {
                  pid: "tree",
                  imgPath:
                    "https://d3f8e2yx8gxglk.cloudfront.net/adaptivemedia/rendition?id=9b705a4f1f492a9b874bb211ac1c4814e272d600",
                  locName: "Econfina Creek Wildlife Management Area",
                  state: "Florida",
                  projType: "Watershed Restoration",
                  locDescription:
                    "Restoring longleaf pine forests helps to limit sedimentation and runoff into Bay County's primary source of drinking water, and improve native habitat for endangered wildlife.",
                  path:
                    "M149.689,138.983a.816.816,0,0,0-.094-.283l-2.81.434a.886.886,0,0,1-1-.755.905.905,0,0,1,.283-.792l2.169-1.886.132-.132V131.08l-7.733,2.245a2.735,2.735,0,0,1-2.377-4.829l6.546-4.753a2.621,2.621,0,0,0,1.056-1.585l.207-.905-3.64,1.151a2.66,2.66,0,0,1-3.339-1.717,2.7,2.7,0,0,1,1.038-3l5.244-3.622a2.68,2.68,0,0,0,1.094-1.679l.377-1.886-1.49.49a2.641,2.641,0,0,1-2.3-4.716l2.867-1.886a2.717,2.717,0,0,0,1.17-1.773l.943-5.659a2.641,2.641,0,0,1,5.225,0l.943,5.659a2.7,2.7,0,0,0,1.151,1.773l2.867,1.886a2.67,2.67,0,0,1-2.32,4.81l-1.49-.509.377,1.886a2.7,2.7,0,0,0,1.094,1.66l5.244,3.622a2.641,2.641,0,0,1-2.3,4.716l-3.64-1.151.208.905a2.809,2.809,0,0,0,1.056,1.6l6.545,4.754a2.736,2.736,0,0,1,.585,3.773,2.679,2.679,0,0,1-2.132,1.132,2.468,2.468,0,0,1-.829-.132l-7.734-2.245v4.4l.132.132,2.169,1.886a.887.887,0,0,1,0,1.245.868.868,0,0,1-.641.3h-.151l-2.81-.415a1,1,0,0,0,0,.283.962.962,0,0,1-1.886,0Z",
                  transform: "translate(-87.317 -57.143)",
                  mapIndex: "5",
                },
                {
                  pid: "tree",
                  imgPath:
                    "https://d3f8e2yx8gxglk.cloudfront.net/adaptivemedia/rendition?id=74acda70f3329e5c352caf7cd2dacd467579f2c7",
                  locName: "Tyndall Air Force Base",
                  state: "Florida",
                  projType: "Hurricane Recovery",
                  locDescription:
                    "In 2018, Hurricane Michael — a Category 5 hurricane — snapped 12k acres of mature pine trees in half. Reforestation efforts can ensure a healthy, forested future for this ground.",
                  path:
                    "M152.643,133.6a1.661,1.661,0,0,0,0-.283l-2.811.434a.905.905,0,0,1-1.018-.754.924.924,0,0,1,.3-.792l2.169-1.886.113-.132v-4.433L143.664,128a2.735,2.735,0,0,1-2.358-4.829l6.546-4.754a2.754,2.754,0,0,0,1.056-1.6l.207-.887-3.641,1.151a2.679,2.679,0,0,1-3.339-1.736,2.622,2.622,0,0,1,1.038-2.98l5.15-3.584a2.585,2.585,0,0,0,1.094-1.66l.377-1.886-1.49.509a2.641,2.641,0,0,1-2.3-4.716l2.867-1.887a2.7,2.7,0,0,0,1.151-1.792l.943-5.659a2.641,2.641,0,0,1,5.225,0l.943,5.659a2.716,2.716,0,0,0,1.169,1.792l2.867,1.886a2.641,2.641,0,0,1-2.3,4.716l-1.49-.49.377,1.886a2.678,2.678,0,0,0,1.094,1.679l5.244,3.622a2.66,2.66,0,0,1-2.3,4.716L158.151,116l.208.906a2.622,2.622,0,0,0,1.057,1.585l6.527,4.754a2.735,2.735,0,0,1-1.547,4.942,3.007,3.007,0,0,1-.811-.113l-7.734-2.245v4.4l.113.132,2.188,1.886a.905.905,0,0,1,0,1.264.942.942,0,0,1-.641.3h-.151l-2.811-.434a1.656,1.656,0,0,0-.094.283.962.962,0,0,1-1.886,0Z",
                  transform: "translate(-68.598 -89.391)",
                  mapIndex: "6",
                },
              ],
            },
            {
              id: "louisiana",
              transform: "translate(746.263 611.288)",
              loc: [
                {
                  pid: "state",
                  path:
                    "M154.06,88.145H104.807v29.75l7.109,16.552,9.9,17.276-7.324,12.192,2.361,11.79-.067.2h0c-.174,1.221-.845,4.936-1.73,8.678l-.765,3.648-.765,1.556c-.188.537-.4,1.046-.59,1.516l24.747.094,11.656,4.681,13.816-2.28,7.793-5.231,5.486,5.5,9.389,11.777,8.8,2.186,9.564-4.788,12.072,2.428,6.076-2.039v-8.785l13.842,11.079,8.705,4.359,3.836-3.836V200.64l-16.807-4.8v-6.2l2.683-2.683,4.225-8.464-6.626-4.426-4.748-11.924-4.936-2.455-2.307-13.8-10.73,2.173-37.436,2.522V139.436l4.869-19.543,9.657-9.631,2.106-6.344-7.055-9.389h0v-.376l-.55-8.3Z",
                  transform: "translate(-104.807 -85.851)",
                },
                {
                  pid: "tree",
                  imgPath:
                    "https://d3f8e2yx8gxglk.cloudfront.net/adaptivemedia/rendition?id=cfa01c49504866109ac81a597f1f51f23d79dbbf",
                  locName: "Kisatchie National Forest",
                  state: "Louisiana",
                  projType: "Watershed and Wildlife Restoration",
                  locDescription:
                    "Centuries of harvesting, land use change, disease, and pests have reduced the forest canopy. Restoration can make this forest more resilient to future stresses and disturbances.",
                  path:
                    "M121.874,132.149a.89.89,0,0,0-.113-.283l-2.792.434a.886.886,0,0,1-.717-1.546l2.169-1.886.113-.132v-4.394l-7.733,2.244a2.734,2.734,0,0,1-2.358-4.827l6.545-4.752a2.81,2.81,0,0,0,1.056-1.6l.189-.886-3.621,1.15a2.679,2.679,0,0,1-3.339-1.735,2.621,2.621,0,0,1,.962-3.017l5.262-3.64a2.584,2.584,0,0,0,1.094-1.659l.377-1.886-1.49.509a2.64,2.64,0,0,1-2.3-4.714l2.848-1.886a2.715,2.715,0,0,0,1.169-1.791l.943-5.657a2.641,2.641,0,0,1,5.225,0l.943,5.657a2.715,2.715,0,0,0,1.169,1.791l2.867,1.886a2.64,2.64,0,0,1-2.32,4.714l-1.49-.49.377,1.886A2.754,2.754,0,0,0,128,107.314l5.262,3.621a2.659,2.659,0,0,1-2.3,4.714l-3.641-1.15.207.905a2.6,2.6,0,0,0,1.037,1.584l6.545,4.752a2.734,2.734,0,0,1-1.547,4.94,3,3,0,0,1-.811-.113l-7.733-2.244v4.394l.113.132,2.169,1.886A.9.9,0,0,1,127.4,132a1.075,1.075,0,0,1-.66.3h-.132l-2.81-.434a.83.83,0,0,0,0,.283.962.962,0,0,1-1.113.773.924.924,0,0,1-.773-.773Z",
                  transform: "translate(-77.023 -73.083)",
                  mapIndex: "7",
                },
              ],
            },
            {
              id: "michigan",
              transform: "translate(816.548 136.263)",
              loc: [
                {
                  pid: "state-mi",
                  path:
                    "M209.62,147.717V133.9l14.406-16.807V103.453l-4.762-9.6-4.748-18.859-3.7-3.729-3.957,3.943L191.9,92.642l-6.076-3.031-2.683-8.236,9.926-14.889,2.186-2.227V50.847l-4.789-4.788V36.844l-6.4-2.133-9.8-2.508L162.54,25.175h-4.118l-6.344,4.252v9.389l-2.522,2.495-2.334,9.3-2.683,8.048h-9.725l-1.931,3.876V74.521l-4.815,9.617v16.23l4.668,9.389,4.936,7.364v24.64l-4.855,9.711-1.422,7.511,19.476-4.292h23.795l7.015-2.361Z",
                  transform: "translate(-32.728 17.814)",
                },
                {
                  pid: "state-mi",
                  path:
                    "M175.694,86.753,188.759,67.1l7.176-2.414,4.936-7.391h9.912L222.962,50l7.471,2.481,18.175-2.267,2.052-6.17-2.052-8.169L235.289,38.09h-8.249L224.732,31.2,204.546,37.9l-7.337,7.35H179.544l-11.884-9.47-15.291,2.548V29.3l6.572-8.759-2.777-1.408L134.865,38l-20.187,8.973,8.316,10.409,19.154,2.388,2.334,2.334h14.312l12.595,10.073h.094v.349l2.361,7.136Z",
                  transform: "translate(-114.678 -19.137)",
                },
                {
                  pid: "tree",
                  imgPath:
                    "https://d3f8e2yx8gxglk.cloudfront.net/adaptivemedia/rendition?id=293101de5ba0e014f9ec8809ddbb2a68b03ceb30",
                  locName: "State Forest Lands",
                  state: "Michigan",
                  projType: "Habitat Restoration",
                  locDescription:
                    "Replanting native species helps return this area to its natural state and improve watershed health. The pine forests will provide habitat for the Kirtland's warbler and other wildlife.",
                  path:
                    "M142.905,76.244a.834.834,0,0,0,0-.283l-2.81.434a.887.887,0,0,1-.717-1.547l2.169-1.886.132-.132v-4.4l-7.734,2.245a2.735,2.735,0,0,1-2.377-4.829l6.545-4.754a2.737,2.737,0,0,0,1.056-1.6l.207-.887-3.641,1.151a2.66,2.66,0,0,1-2.3-4.716L138.68,51.4a2.526,2.526,0,0,0,1.094-1.66l.377-1.886-1.471.509a2.66,2.66,0,0,1-2.32-4.716l2.867-1.886A2.716,2.716,0,0,0,140.4,39.97l.943-5.659a2.641,2.641,0,0,1,5.225,0l.943,5.659a2.7,2.7,0,0,0,1.151,1.792l2.867,1.886a2.641,2.641,0,0,1-2.3,4.716l-1.49-.49.377,1.886a2.678,2.678,0,0,0,1.094,1.679l5.244,3.622a2.66,2.66,0,0,1-2.3,4.716l-3.64-1.151.208.905a2.716,2.716,0,0,0,1.056,1.584l6.545,4.754a2.735,2.735,0,0,1-1.547,4.942,3.148,3.148,0,0,1-.83-.113l-7.734-2.245v4.4l.132.132,2.169,1.886a.887.887,0,0,1,0,1.264.981.981,0,0,1-.641.3h-.151L144.924,76a.89.89,0,0,0-.113.283.962.962,0,0,1-1.886,0Z",
                  transform: "translate(-18.083 59.924)",
                  mapIndex: "8",
                },
              ],
            },

            {
              id: "new-mexico",
              transform: "translate(328.889 462.51)",
              loc: [
                {
                  pid: "state",
                  path:
                    "M152.69,74.426l-85.2-9.47L46.19,244.933l19.462,2.173,4.668-11.669,8.048-2.683,32.446,6.961v-6.988l100.866,7.189,9.51-145.21h0l.094-1.113h.121l2.012-12.152Z",
                  transform: "translate(-46.19 -64.956)",
                },
                {
                  pid: "tree",
                  imgPath:
                    "https://d3f8e2yx8gxglk.cloudfront.net/adaptivemedia/rendition?id=afc7807e1be6081696ea94ea30b5fe7c18d734ca",
                  locName: "Cibola National Forest",
                  state: "New Mexico",
                  projType: "Wildfire Recovery, Wildlife Habitat Restoration",
                  locDescription:
                    "A wildfire blazed through habitat for important wildlife and migratory bird species. Reforestation is critical to support this wildlife and to protect a priority watershed in the area.",
                  path:
                    "M71.337,113.877a1.006,1.006,0,0,0,0-.284l-2.81.417a.868.868,0,0,1-1-.738.835.835,0,0,1,.283-.8l2.169-1.894a.861.861,0,0,0,.132-.133v-4.412l-7.79,2.31a2.726,2.726,0,0,1-2.377-4.829l6.545-4.772a2.823,2.823,0,0,0,1.056-1.61l.208-.909-3.641,1.155a2.669,2.669,0,0,1-2.3-4.734l5.244-3.636a2.691,2.691,0,0,0,1.094-1.685l.377-1.894-1.49.511a2.669,2.669,0,0,1-2.3-4.753L67.6,79.3a2.6,2.6,0,0,0,1.151-1.78l.943-5.681a2.658,2.658,0,0,1,5.244,0l.943,5.681a2.6,2.6,0,0,0,1.151,1.78L79.9,81.191a2.669,2.669,0,0,1-2.3,4.753l-1.49-.511.377,1.894a2.652,2.652,0,0,0,1.094,1.666l5.244,3.636a2.65,2.65,0,0,1-2.3,4.734l-3.64-1.136.207.89a2.822,2.822,0,0,0,1.056,1.61l6.545,4.772a2.748,2.748,0,0,1-1.622,4.848,3.025,3.025,0,0,1-.83-.113l-7.734-2.273v4.412a.438.438,0,0,0,.132.132l2.169,1.894a.893.893,0,0,1,0,1.25.866.866,0,0,1-.641.3h-.151l-2.811-.417a1.677,1.677,0,0,0-.094.284A.943.943,0,0,1,72,114.6a.964.964,0,0,1-.773-.776Z",
                  transform: "translate(30.979 -36.448)",
                  mapIndex: "9",
                },
              ],
            },
            {
              id: "oregon",
              transform: "translate(19.61 79.781)",
              loc: [
                {
                  pid: "state",
                  path:
                    "M185.1,136.027l5.016-7.686-2.213-8.558-5.526-7.927,26.33-29.227,2.481-11.924-6.975-8.665-13.346-2.119-25.834-9.389-28.449.121-24.036-3.085-8.772-4.52L85,43.168l-7.431-5.459,4.373-12.394-6.251-6.707L73.361,14.2,56.1,11.2,50.29,33.752,26.227,85.312,7.14,114.512l-4.386,23.3,94.4,35.142,76.213,17.893Z",
                  transform: "translate(-2.754 -11.205)",
                },
                {
                  pid: "tree",
                  imgPath:
                    "https://d3f8e2yx8gxglk.cloudfront.net/adaptivemedia/rendition?id=869cf719082a271b61f0763797127809089fc211",
                  locName: "Josephine County",
                  state: "Oregon",
                  projType: "Fire Rehabilitation",
                  locDescription:
                    "48,000+ forested acres were severely burned during the 2013 fire season. These trees are critical for area wildlife and can help minimize the potential for sedimentation in area waterways.",
                  path:
                    "M20.159,67.524a1,1,0,0,0,0-.283l-2.81.416a.868.868,0,0,1-1-.737.832.832,0,0,1,.283-.794l2.169-1.89.132-.132V59.7l-7.884,2.211a2.74,2.74,0,0,1-2.377-4.838l6.545-4.762a2.721,2.721,0,0,0,1.056-1.587l.207-.907-3.64,1.153a2.664,2.664,0,0,1-2.3-4.724l5.244-3.628a2.684,2.684,0,0,0,1.094-1.682l.377-1.89-1.49.491a2.645,2.645,0,0,1-2.3-4.724l2.867-1.89a2.589,2.589,0,0,0,1.151-1.776l.943-5.669a2.659,2.659,0,0,1,5.244,0l.943,5.669a2.589,2.589,0,0,0,1.151,1.776l2.867,1.89a2.664,2.664,0,0,1-2.3,4.743l-1.49-.51.377,1.89A2.646,2.646,0,0,0,26.308,42.6l5.244,3.628a2.645,2.645,0,0,1-2.3,4.724L25.61,49.8l.207.907a2.816,2.816,0,0,0,1.056,1.606l6.545,4.762a2.741,2.741,0,0,1-1.547,4.951,2.467,2.467,0,0,1-.83-.132l-7.733-2.249v4.4a.434.434,0,0,0,.132.132l2.169,1.89a.889.889,0,0,1,0,1.247.867.867,0,0,1-.641.3h-.151l-2.81-.416a1.665,1.665,0,0,0-.094.283.962.962,0,0,1-1.886,0Z",
                  transform: "translate(26.683 62.579)",
                  mapIndex: "10",
                },
              ],
            },

            {
              id: "",
              transform: "translate(1101.737 328.379)",
              loc: [
                {
                  pid: "inactive-state",
                  path:
                    "M154.731,54.842l3.8,13.279,10.811-12.944,9.389-2.361,2.146-4.292C168.734,51.636,158.647,54.117,154.731,54.842Z",
                  transform: "translate(-154.731 -31.396)",
                },
                {
                  pid: "inactive-state",
                  path:
                    "M220.8,46.118c-8.49,2.294-38.442,10.355-62.022,16.444h8.678l4.963,7.458,3.742,1.878.241-.241.7.711,1.341.657-.308.322,1.341,1.341,12.3,2.455,2.777,8.33-2.481,5v3.568l8.558,2.16h9.9L206.5,87.914l-2.388-24,2.267-.617,11.9,26.142,11.777,9.389,1.918,1.945,10.516-4.2V86.6H228.247L220.83,49.633V46.145Z",
                  transform: "translate(-129.943 -46.118)",
                },
              ],
            },
          ],
          mapInactive: [
            {
              pid: "inactive-state",
              path:
                "M219.06,123.137l9.389-11.7,2.428-9.711,19.489-17.061,13.6-13.628-4.024-5.982-9.671-2.428-4.829-9.59-9.47-2.334-5.231-8.048L225.954,21.2,219.086,7.422,210.6,5.3l-12.139,9.711-5.218-2.6h-6.09l-6.841,18.175v19.02l2.428,21.81-7.149,14.325L182.7,114.1l7.1,18.926,12.823,19.248,4.212-16.887Z",
              transform: "translate(1074.658 32.455)",
            },
            {
              pid: "inactive-state",
              path:
                "M178.346,29.975v8.37l2.481,7.5-4.909,9.832-2.361,30.77L178,106.456l20.281-9.014,13.842-4.614,2.133-8.45L200.035,62.917l-7.2-19.181-6.706-26.826-7.753,7.739Z",
              transform: "translate(1062.23 103.499)",
            },
            {
              pid: "inactive-state",
              path:
                "M204.6,93.563,200.01,73.054l2.548-31.816,4.587-9.161-2.321-7.109V19.12l-17.692,2.213-18.3,6.868V39.133L173.627,51.2l2.28,18.161H180.6l4.909,22.185,4.158,4.131Z",
              transform: "translate(1033.349 117.022)",
            },
            {
              pid: "inactive-state",
              path:
                "M187.831,42.178l-1.194.536-.094-.362-14.674,2.092V65.906l46.45-11.669.671-.215.469.5L231.075,63.8h7.632l2.428,7.2h7.042l-2.133-6.452,10.073-7.538,1.958-3.93-4.024-6.076h-4.319l4.788,7.189H244.7l-9.926-7.431-7.82-7.793,2.28-9.188-5.727-1.9L188.891,41.7V42Z",
              transform: "translate(1051.9 170.634)",
            },
            {
              pid: "inactive-state",
              path: "M177.639,33.748l4.2,19.06,7.578-3.8V38.282L183,31.937Z",
              transform: "translate(1087.214 195.468)",
            },
            {
              pid: "inactive-state",
              path:
                "M171.892,49.882,178.6,74.508l27.711-18.47h8.772V52.591l-4.534-20.307-38.683,9.107Z",
              transform: "translate(1051.876 197.589)",
            },
            {
              pid: "inactive-state",
              path:
                "M295.3,89.055l-4.668-4.708-4.695-20.991H281.1l-2.522-20.12L273.76,30.95V20.514l-29.308,9.027L214.3,64.227l6.613,4.4V86.668L198.553,104.1l-37.181,2.32,6.961,20.857-17.021,14.58v9.912l46.812-11.669h9.389l29.053-11.991H251.32l10.288,2.575,2.4,9.564,10.221,2.039v-.08l1.06.3,1.341.255v.08l4.024,1.1,4.265.939,16.82,4.815.939.255h0v7.176l8.128,2.025,26.826-20.12-2.508-1.234-21.3,11.83h-9.563l-1.073.738-.174-.738h0L295.5,122.051v-33Z",
              transform: "translate(926.08 125.554)",
            },
            {
              pid: "inactive-state",
              path:
                "M172.444,64.616l10.073,10.046L167.844,94.138l3.863,9.7,1.811-1.811,14.151,9.389,8.839-15.532,2.374-11.817V72.476l-2.253-9.121-5.164-5.137,2.978-5.929,4.467-2.253V44.5l-20.227-5.513-4.252-.939-4.265,12.85Z",
              transform: "translate(1027.261 232.846)",
            },
            {
              pid: "inactive-state",
              path:
                "M188.313,73.685l-19.194-21.6V49.528l-1.113-2.213,1.073,6.519,4.614,23h14.62Z",
              transform: "translate(1028.253 289.582)",
            },
            {
              pid: "inactive-state",
              path:
                "M164.926,131.847l23.889-2.173v-.148h1.529l92.939-23.835,13.534-18.027L287.7,78.53l-2.508-15.09,4.386-13.158-10.61-2.347-.724-.161h0l-2.428-9.617-8.732-2.2H253L223.97,48.029h-9.389l-49.4,12.233V49.612L148.656,66.15l4.4,8.92,2.522,5.057h0l4.8,31.306v.161l-.121,1.341.094.724Z",
              transform: "translate(909.824 220.071)",
            },
            {
              pid: "inactive-state",
              path:
                "M146.567,143.2l11.656,2.334,4.708,7.082h9.456l2.414,2.388h13.413l5.3-5.285,7.7,7.713h8.182l4.52-15.841.174-.657,7-2.334v-9.389l14.647-9.765,4.574-9.121,2.24-24.613L237.924,53.4,231.445,40.42l-23.178,16.1-14.754,4.869h-14.7l-9.523-4.748-28.4,4.735L134.818,63.4Z",
              transform: "translate(825.13 247.384)",
            },
            {
              pid: "inactive-state",
              path:
                "M256.467,61.427l-.778-.4-4.628-6.935h-8.209l-2.334,4.628-9.725,2.455L217.583,77l-5.178-18.027-26.424,2.414L182.6,47.893l-1.824,17.544-4.963,9.872L161.69,84.7v9.818L154.3,96.958l-2.253,8.987-2.387,7.35-.242.845h-4.507v8.048l6.814,9.094,10.959,6.572.094-.08.8.617,1.207.724-.121.107,8.155,6.089,6.8-1.127,6.814-1.14,7.015-4.654,11.441-6.881V117.319L209.763,110l2.495-9.872L224.477,92.8l7.055-9.389,9.215-11.522-2.6-7.806,11.374-2.83,6.841,4.534,2.615-2.683Z",
              transform: "translate(886.904 293.121)",
            },
            {
              pid: "inactive-state",
              path:
                "M262.912,50.125l-7.833,1.945,2.186,6.6-.577.724L239.734,81.056,228.145,88l-2.428,9.483-4.614,6.894v14.754l-.711.429-19.476,12.072-14.9,2.481-.416-.3-9.134-6.116L153.381,153.03l-10.73,7.136,48.153-6.894,117.633-21.6,27.309-9.121-3.863-7.7H320.145l-8.262-8.236,4.882-7.3L309.08,89.05l6.586-2.186-7.605-5.727-12.072-4.869-7.055-4.681-.684-.174V65.376l2.307-4.6-2.025-6.063-11.683-2.334-.174-.174-1.931-1.341-4.359,4.346Z",
              transform: "translate(873.068 306.783)",
            },
            {
              pid: "inactive-state",
              path:
                "M205.328,98v.08l-.4.308-4.762,4.735L185.3,113.034l-6.961,2.32L161.386,129.8,149.623,134.5l-9.094,9.081v5.5h29.656l14.285-9.51,12.447-4.9h23.822l7.7-2.575,5.674,5.687v6.478h5.5l4.721-4.721,17.437-2.495,10.113,2.535,21.461,19.087h4.118l11.777-4.695,6.452-2.173V142.57l19.959-19.811,11.213-4.493v-5.888l-7.042-7.122-3.071-6.143,20.334-5.07,4.024-4.024-1.945-5.982-6.438-2.146H337.312V77.543l9.966-5L351.6,66.1l-1.878-5.5-27.644,9.215L205.381,91.278Z",
              transform: "translate(860.086 370.909)",
            },
            {
              pid: "inactive-state",
              path:
                "M144.911,95.539l4.1,4.024h7.27l12.327,14.848,28.65,23.822,7.3,7.27.161.161h0l2.414,7.189,7,7,4.587,6.854h3.166l2.294-11.334,2.683-5.459h9.845L243.2,143.4v-7.189l7.525-7.552,6.867-4.587v-9.389l13.212-17.6h-5.258l-21.7-19.3-9.094-2.28-16.19,2.307-4.842,4.882h-8.8V74.95L201,71.033l-6.868,2.227H170.342l-11.669,4.654-13.762,9.107Z",
              transform: "translate(886.904 434.747)",
            },
            {
              pid: "inactive-state",
              path:
                "M222.22,159.407l-19.006-45.175-11.75-39.823-27.752,4.614c-1.341.2-29.764,4.252-37.329,4.762l2.361,92.416,4.695,58.83h12.97l10.838-6.532-1.127-3.085L149.9,208.862h0l1.556-.228,31.078-4.762,39.582-4.721-4.654-25.485Z",
              transform: "translate(773.513 455.408)",
            },
            {
              pid: "inactive-state",
              path:
                "M283.56,72.03,276.6,76.685h-.241L182.707,88.7l-.791.241-16.015,4.6H135.05l-4.024,4.024-.121,4.775-7.028,16.391v.121l-.268.4-1.194,2.8-.215-.671-3.246,4.869v15.278l31.561-1.5,18.872-.858v-.067h1.207l66.931-9.577,7.109-2.347,25.565-4.668v-6.706l10.342-10.221,11.83-4.721,17.035-14.5,7.015-2.32L335,70.112V64.975c-7.069,1.341-37.892,7.31-48.515,7.31A10.409,10.409,0,0,1,283.56,72.03Z",
              transform: "translate(728.041 397.669)",
            },
            {
              pid: "inactive-state",
              path:
                "M125.2,145.357l-3.729,5.62h28.744l16.646-4.748,33.747-4.842,38.428-4.8,21.327-2.347,5.231-3.5h0l16-10.73,22.521-24.72-10.73-7.176L285.969,78.2V69.412h-4.118l-6.706-6.707-4.306,4.319H255.481l-2.334-2.441h-9.792l-4.882-7.31L228.4,55.194V66.233l-5.5,5.5h-8.906v4.024l-7.31,9.738-2.455,9.939-6.076,3.018-5.057-5.07H190V100.4l-15.425,2.562-20.992,2.334-2.119,4.212-12.072,19.288-.308.59H127.1l-1.931,3.89Z",
              transform: "translate(743.444 337.809)",
            },
            {
              pid: "inactive-state",
              path:
                "M148.357,170.926l13.319-2.227v-7.377h6.559l4.507,4.52L176.3,164.1l2.455-9.5,6.975-9.282v-5.58h10.288l4.1-4.118V124.182L188.274,43.7h-22.8L144.011,48.76l-4.56,4.534H128.17V78.577l2.361,14.2,2.428,7.4v16.284l2.575,2.575-2.575,7.713v9.121l2.455,4.936-2.683,10.355L125.7,162.892v11.374l.4-.818Z",
              transform: "translate(769.339 267.48)",
            },
            {
              pid: "inactive-state",
              path:
                "M149.624,127.965v1.127l.268,1.261h-.268V147.91l4.359,4.346,11.535,6.935,63.685-4.735-2.79-44.692,4.842-9.711,2.361-16.605,1.341-6.881-4.024,5.365L219.157,93.708V80.724l4.721-4.695-4.6-22.936-11.321-9.067H193.538l-2.468-2.455-19.328-2.428-9.6-11.991L145.8,24.805l-7.015-2.32-13.869,4.628L118.4,31.471v19.3l-9.792,4.882L106.5,64.038l2.226,2.227,2.4,26.062,14.1,4.788L147.142,116.6l.094.4,2.186,10.958Z",
              transform: "translate(651.821 137.614)",
            },
            {
              pid: "inactive-state",
              path:
                "M141.347,64.292,133.809,76.82,121.858,84l-1.7,3.42,4.654,2.32-2.884,8.517-7.109,9.389-2.253,6.707,2.307,20.884,19.1,16.686,2.28,6.908,9.872,2.455v15.613l-2.213,4.44,4.145,6.21,12.072,2.388,5.2,7.9,6.868,20.884h3.447l1.9-1.9,2.683-5.365H192.3l11.482-20.723V176.372L211.1,164.3l2.24-9L211,150.632V140.371l2.173-6.519-2.213-2.213V114.5l-2.334-6.961-2.455-14.607V66.6L192.411,41.383c-7.444.322-51.251,3.541-61.821,4.319l10.73,12.93v5.66Z",
              transform: "translate(688.922 253.276)",
            },
            {
              pid: "inactive-state",
              path:
                "M168.258,39.987,95.036,42.334V72.151l9.523,26.2,7.042,35.209H211.6l3.568,1.207,2.683.9,2.24-6.425,7.055-9.389,2.025-6.022-4.936-2.468,3.085-6.183,12.072-7.243,6.894-11.441V82.466l-11.6-13.923-12.072-7.27-5.177-5.151V38.779l-.174-1.127Z",
              transform: "translate(581.654 230.448)",
            },
            {
              pid: "inactive-state",
              path:
                "M104.991,113.128v.738h-.7l-6.237,6.183,1.931,3.85,7.417,7.4v59.246l68.407-2.347,53.438-2.32-1.784-10.248-21.112-18.778-14.9-4.963L189,125.146l-2.575-2.562,2.683-10.73,9.389-4.721V88.005l.376-.268,19.114-21.461,17.088-17.061,17.558-9.738H237.686l-4.856-4.829h-6.4l-4.815,2.414H209l-7.015-4.681-7.525,2.508-5.03-7.552L176.013,25.1l-4.721,2.4h-7.873L141.836,13.039H93.013V42.91l11.978,55.316v13.239h1.636Z",
              transform: "translate(569.271 79.806)",
            },
            {
              pid: "inactive-state",
              path:
                "M71.125,110.439l77.917,4.708,87.52,2.361V104.471L231.8,83.01l-7.189-33.841V19.123l-75.65-2.347L78.14,12.041,75.807,66Z",
              transform: "translate(435.312 73.695)",
            },
            {
              pid: "inactive-state",
              path:
                "M76.949,55.032h0l-.107,1.194-.08,1.207h-.067l-6.921,62.344L198.1,126.9h.282l11.924,7.149,21.6-2.387,12.072,7.216h3.246V51.813l-7.055-7.163-2.79-5.566,5.835-5.848-86.018-2.32L79.162,26.194Z",
              transform: "translate(427.034 160.315)",
            },
            {
              pid: "inactive-state",
              path:
                "M73.724,39.676,69.1,99.686l47.912,4.8v31.159l80.478,4.721,43.083,1.194,40.239,1.073-9.765-9.792-.268-.2-1.811-7.216-.456-1.851h0l-.215-.939-.335-1.462h0l-6.894-34.566-9.657-26.625V58.79h-3.917l-11.938-7.163-21.6,2.414-12.072-7.27-57.314-2.388Z",
              transform: "translate(422.895 242.83)",
            },
            {
              pid: "inactive-state",
              path:
                "M262.259,88.775l-9.389-7.069-2.683-8.048,4.467-8.96-3.93-2.025L248.3,60.595l-44.759-1.247-45.6-1.194L79.828,53.5,75.8,136.056,75.16,149.47l87.587,4.628h99.512Z",
              transform: "translate(460.008 327.432)",
            },
            {
              pid: "inactive-state",
              path:
                "M289.822,114.289,287.394,92.6V88.925l-2.6.107,2.548-1.891-1.221-8.49c-.5-2.924-.885-5.164-1.019-6.559H185.442L96.58,67.3H71.444V79.375l74.08,4.775,2.683,8.182-2.388,57.113,6.344,4.225h12.152l7.337,7.35,13.789,4.614,9.939-2.481,7.391,7.391,16.283,2.347,19.61-2.455,4.695,4.695,6.492-2.173,14.593-2.441h14.929l15.17,8.678-2.307-53.035Z",
              transform: "translate(437.261 411.919)",
            },
            {
              pid: "inactive-state",
              path:
                "M44.847,154.436l29.509,5.607L94.086,163.8h.469L215.1,175.669l.765-9.818,3.863-50.138h-.067l.161-1.234.08-1.167h0l6.707-62.451-70.526-7.069L68.373,27.226Z",
              transform: "translate(274.478 166.633)",
            },
            {
              pid: "inactive-state",
              path:
                "M122.319,154.308h0l89.948,17.035,70.445,7.028.121-1.18,2.347-27.47h0l.134-1.274.08-1.14h0l4.721-46.838L292.4,48.8l-56.469-7.069-67.213-9.59L82.281,15.322,42.712,6,40.445,19.52l-4.721,4.721v16.3l2.294,18.4,9.7,4.842v14.5l14.754,9.845L52.463,108.14l-2.28,11.334,3.38,5.07,1.811-3.595h9l4.856,31.574,4.654,2.334,4.668,11.669H106.33l7.4-2.455,6.277,2.092,2.119-10.623Z",
              transform: "translate(218.642 36.721)",
            },
            {
              pid: "inactive-state",
              path:
                "M57.661,96.393l7.793,10.422-2.575,12.85L36.911,148.006l4.44,6.787,2.508,10.113L38.9,172.364,26.959,227.291l49.467,11.938L90.791,242.7l66.019,14.151,16.351-84.18-5.808-1.931-7.2,2.32H130.561l-4.936-12.327-4.963-2.468-4.735-30.85H110.5l-2.978,5.982-6.224-9.389,2.589-12.783L113,92.972l-14.03-9.389V69.392l-9.51-4.748L86.982,44.806V27.369L91.851,22.5l2.16-12.944L77.043,5.318,69.237,35.7,53.852,95.789Z",
              transform: "translate(164.996 32.547)",
            },
            {
              pid: "inactive-state",
              path:
                "M124.516,84.144h0l.215-1.14,4.6-30.072L64.439,39.022l-33.063,158.4,124.742,23.527,15.251-102.825,3.595-24.385Z",
              transform: "translate(192.032 238.83)",
            },
            {
              pid: "inactive-state",
              path:
                "M141.78,78.113l-5.929,1.972,11.656,39.689,19.342,45.886-4.856,14.526,4.668,25.74,6.586,6.572,54.658-2.4h20.656l2.414-11.938H265.14V167.78l4.949-7.377,2.119-6.479-4.467-6.707L260.5,140l-2.361-7.163-35.773-30.984L210.589,87.744h-7.136l-5.486-5.486V73.365H168.083Z",
              transform: "translate(831.459 449.02)",
            },
            {
              pid: "inactive-state",
              path:
                "M112.769,70.7h.308l7.458,4.949.979.5L116.4,86.379l2.106,6.371,9.778,7.337v67.7l1.046,7.337c.094.51.188,1.006.241,1.489.617,3.514.966,5.58,1.113,6.814l58.749-2.347H225.2l4.788-2.4h21.032l-2.683,10.435,4.534,4.507,1.462,4.373,3.554-8.96,2.307-9.309v-.349l.121-.107,4.963-4.949,4.534-6.814v-8.718l-.7.7h-6.17l-7.418-22.252-4.44-6.707-11.978-2.4-5.472-8.2,2.575-5.164V101.576l-9.309-2.32-2.522-7.511-19.315-16.9L202.7,53.557l-6.277-2.106H97.438l1.918,7.739Z",
              transform: "translate(596.353 314.9)",
            },
            {
              pid: "inactive-state",
              path:
                "M144.976,78.088,136.15,84.7V98.878L121.8,120.42l2.267,24.774h.107v1.234l.081,1.18h-.081v8.048l7.337,9.778-2.683,8.048-9.577,9.577-4.668,18.778v8.155l34.7-2.32,13.064-2.616,2.508,15.023,4.681,2.334,4.815,12.072,5.768,3.85,2.092-4.252h16.914l4.2-6.331L198.575,168.2,196.2,75.727l-42.345,1.918Z",
              transform: "translate(701.282 463.478)",
            },
            {
              pid: "inactive-state",
              path:
                "M403.55,170.082h-9.523v.939l-1.61-.939H391.6v-.469l-15.962-9.121H361.58L349.8,162.865l-9.5,2.374-.644.228h0l-4.909-4.936-18.778,2.347L298.633,160.4l-6.988-7-9.3,2.32-15.036-4.976-7.042-7.055h-11.9l-8.048-5.365,2.387-58.038-2.079-6.224-74.711-4.735-9.617,146.444-1.194-.08L55.6,208.577v5.365l45.5,45.47,7.163,28.664,37.315,23.339,6.371-4.239,12.072-19.342,7.914-2.683,24.613,4.936,17.263,14.754,7.31,19.489,11.857,21.313,16.9,19.462,2.414,14.526L266.4,403.121l18.6,9.322h17.182l4.788,7.189h5.365V406.447l-4.788-31.306,7.3-19.5,7.578-14.889,14.647-12.206,14.754-2.455h13.936l4.453-6.707,9.282-9.309-2.414-12.166,9-5.982,4.936,9.872,6.224-2.079,13.883-6.961,1.435-2.844c.523-1.6,1.073-3.648,1.6-5.808l1.435-7.23-2.455-12.219,7.109-11.79-9.255-16.19-7.364-17.437V170.082Z",
              transform: "translate(340.299 424.279)",
            },
            {
              pid: "inactive-state",
              path:
                "M120.338,279.723l-2.481-29.683h11.562l4.668,7.042,7.887-1.972V244.044l2.253-15.827h-.094l.268-1.18.134-1.18h.094l33.117-158.5L109.259,50.828,38.411,34.3,12.484,121.488l104.26,163.505Z",
              transform: "translate(76.405 209.949)",
            },
            {
              pid: "inactive-state",
              path:
                "M28.439,80.975l2.522,5.177L38.4,93.731l-2.575,7.9-1.945,4.024,5.862,4.024H58.457l9.47,4.829,23.258,2.361h28.3l26.048,9.657,8.316,1.341,22.8-90.619L97.8,13.641,64.359,0l2.092,12.689L61.73,22.306l2.4,17.021-7.3,7.417L51.925,61.928,40.376,59.018l2.79-13.641,6.613-9L45.487,27.6C35.7,17.611,24.562,7,22.778,6.479c-.939,0-3.662,2.079-5.727,4.118V22.1l-2.32,24.117V65.5L10.3,78.748l2.173.362.228-.791Z",
              transform: "translate(63.065)",
            },
          ],
        };
      },
    },
  },
  mounted() {
    const qnMap = document.querySelector("#QN-map");
    if (qnMap) {
      jQuery(".container-fluid").addClass("QN-map");
      if (screen.width < 767) {
        document.querySelector("html").setAttribute("style", "overflow:hidden");
        document
          .querySelector("body")
          .setAttribute("style", "overflow-x:hidden");
      }
    }
    if (screen.width < 767) {
      this.showBtn = true;
      setTimeout(() => jQuery(".triangle-right").trigger("click"), 300);
    } else {
      this.showBtn = false;
    }
  },
  created: function () {
    if (screen.width > 767) {
      var ref = this;
      document.addEventListener("keyup", function (event) {
        var key = event.key || event.keyCode;
        if (key === "Escape" || key === "Esc" || key === 27) {
          this.projectImage = "";
          ref.closePopUp();
        }
      });
    }
  },
  methods: {
    showTreeDetails(event, mi) {
      const mapContainer = document.querySelector("#map-section");
      const infoBox = document.querySelector("#map-details-section");
      let projectCount = 0;
      let projectDetails = [];
      for (var am = 0; am < this.mapData.mapActive.length; am++) {
        for (var pc = 0; pc < this.mapData.mapActive[am].loc.length; pc++) {
          if (this.mapData.mapActive[am].loc[pc].pid == "tree") {
            projectCount++;
            projectDetails.push(
              Object.entries(this.mapData.mapActive[am].loc[pc])
            );
          }
        }
      }
      if (screen.width < 767) {
        // Mobile
        // if (mi) {
        //   //looping
        //   if (this.num >= projectCount) {
        //     this.num = 0;
        //   }
        //   //Populate project details
        //   this.projectImage = projectDetails[this.num][1][1];
        //   this.locationName = projectDetails[this.num][2][1];
        //   this.stateName = projectDetails[this.num][3][1];
        //   this.projectType = projectDetails[this.num][4][1];
        //   this.locationDescription = projectDetails[this.num][5][1];
        //   this.num++; // For Right slider
        // } else if (!mi) {
        //   //looping
        //   if (this.num == 1) {
        //     this.num = projectCount + 1;
        //   }
        //   this.num--; // For Left slider
        //   //Populate project details
        //   this.projectImage = projectDetails[this.num - 1][1][1];
        //   this.locationName = projectDetails[this.num - 1][2][1];
        //   this.stateName = projectDetails[this.num - 1][3][1];
        //   this.projectType = projectDetails[this.num - 1][4][1];
        //   this.locationDescription = projectDetails[this.num - 1][5][1];
        // }

        if (mi == 1) {
          //looping
          if (this.num >= projectCount) {
            this.num = 0;
          }
          //Populate project details
          this.projectImage = projectDetails[this.num][1][1];
          this.locationName = projectDetails[this.num][2][1];
          this.stateName = projectDetails[this.num][3][1];
          this.projectType = projectDetails[this.num][4][1];
          this.locationDescription = projectDetails[this.num][5][1];
          this.num++; // For Right slider
          this.dataIndex = this.num;
          const activeTree = document.querySelectorAll(
            '[data-index="' + this.num + '"]'
          );
          jQuery("path").removeClass("treeActive");
          jQuery(activeTree).toggleClass("treeActive");
        } else if (mi == 0) {
          //looping
          if (this.num == 1) {
            this.num = projectCount + 1;
          }
          this.num--; // For Left slider
          //Populate project details
          this.projectImage = projectDetails[this.num - 1][1][1];
          this.locationName = projectDetails[this.num - 1][2][1];
          this.stateName = projectDetails[this.num - 1][3][1];
          this.projectType = projectDetails[this.num - 1][4][1];
          this.locationDescription = projectDetails[this.num - 1][5][1];
          this.dataIndex = this.num;
          const activeTree = document.querySelectorAll(
            '[data-index="' + this.num + '"]'
          );
          jQuery("path").removeClass("treeActive");
          jQuery(activeTree).toggleClass("treeActive");
        } else {
          this.projectImage = mi.imgPath;
          this.locationName = mi.locName;
          this.projectType = mi.projType;
          this.stateName = mi.state;
          this.locationDescription = mi.locDescription;
          this.projectIndex = mi.mapIndex;

          const activeTree2 = document.querySelectorAll(
            '[data-index="' + this.projectIndex + '"]'
          );
          jQuery("path#tree").removeClass("treeActive");
          jQuery(activeTree2).toggleClass("treeActive");
          //Changes the index last set by arrows to current map index
          this.num = this.projectIndex;
        }

        this.dataIndex = this.num;
        const activeTree = document.querySelectorAll(
          '[data-index="' + this.num + '"]'
        );

        var liveTree = activeTree[0];
        var rectEl = liveTree.getBoundingClientRect();

        // jQuery("path").removeClass("treeActive");
        // jQuery(activeTree).toggleClass("treeActive");

        // Finding center point of Map
        var midX = jQuery(mapContainer).width() / 2;
        var midY = jQuery(mapContainer).height() / 8;

        // Finding the tree point
        var pointX = rectEl.left - jQuery(mapContainer).offset().left;
        var pointY = rectEl.top - jQuery(mapContainer).offset().top;

        // Moving tree to center point
        var relX = midX - pointX - screen.width / 3;
        var relY = midY - pointY;

        mapContainer.setAttribute(
          "style",
          `-webkit-transform: translate(${relX}px,${relY}px);transform: translate(${relX}px,${relY}px);`
        );

        // infoBox.style.display = "block";
      } else {
        if (jQuery("path").hasClass("treeActive")) {
          return false;
        }
        this.showBtn = false;
        // Tab and Desktop
        var relX = event.pageX - jQuery(mapContainer).offset().left;
        var relY = event.pageY - jQuery(mapContainer).offset().top;

        // Zoom based on mouse coordinates
        var size = { w: mapContainer.width, h: mapContainer.height };
        var pos = { x: 0, y: 0 };
        var zoom_target = { x: 0, y: 0 };
        var zoom_point = { x: 0, y: 0 };
        var scale = 1;

        zoom_point.x = relX;
        zoom_point.y = relY;

        var delta = event.delta || 0.4;
        delta = Math.max(-1, Math.min(1, delta));

        // determine the point on where the slide is zoomed in
        zoom_target.x = (zoom_point.x - pos.x) / scale;
        zoom_target.y = (zoom_point.y - pos.y) / scale;

        // apply zoom
        scale += delta * 0.5 * scale;
        scale = Math.max(1, Math.min(1.4, scale));

        // calculate x and y based on zoom
        pos.x = -zoom_target.x * scale + zoom_point.x;
        pos.y = -zoom_target.y * scale + zoom_point.y;

        mapContainer.setAttribute(
          "style",
          "transform: scale(" + scale + "," + scale + ")"
        );

        // East and West Details display
        var midX = jQuery(mapContainer).width() / 2;
        var infoLft = event.pageX - jQuery(mapContainer).offset().left;
        if (infoLft > midX) {
          infoLft = infoLft - jQuery(infoBox).outerWidth();
        }

        if (screen.width > 1024) {
          jQuery(infoBox).css({
            left: infoLft + 185,
            top:
              event.pageY - jQuery(infoBox).height() / 2 >= 100
                ? 100
                : event.pageY - jQuery(infoBox).height() / 2,
          });
        } else {
          jQuery(infoBox).css({
            left: midX - jQuery(infoBox).width() / 2,
            top: jQuery(mapContainer).height() / 8,
          });
        }
        const activeTree = document.querySelector(
          '[data-index="' + event.target.getAttribute("data-index") + '"]'
        );
        infoBox.style.display = "block";
        this.projectImage = mi.imgPath;
        this.locationName = mi.locName;
        this.projectType = mi.projType;
        this.stateName = mi.state;
        this.locationDescription = mi.locDescription;
        // event.target.classList.toggle("treeActive");
        jQuery(activeTree).toggleClass("treeActive");
        jQuery(mapContainer).addClass("details-open");

        setTimeout(
          () => (this.dataIndex = event.target.getAttribute("data-index")),
          300
        );
      }
    },
    removeDetails() {
      if (screen.width > 767) {
        if (!jQuery("path").hasClass("treeActive")) {
          return false;
        }
        this.projectImage = "";
        const mapContainer = document.querySelector("#map-section");
        const infoBox = document.querySelector("#map-details-section");
        infoBox.style.display = "none";
        infoBox.setAttribute("style", "display:none;left:0px;top:0px");
        const closePop = document.querySelector(".close-modal");
        closePop.setAttribute("style", "left:auto;");
        const activeTree = document.querySelector(
          '[data-index="' + this.dataIndex + '"]'
        );
        mapContainer.setAttribute("style", "transform: scale(1)");
        // activeTree.classList.remove("treeActive");
        jQuery(activeTree).removeClass("treeActive");
        // mapContainer.classList.remove("details-open");
        jQuery(mapContainer).removeClass("details-open");
        this.dataIndex = -1;
      }
    },
    closePopUp() {
      if (!jQuery("path").hasClass("treeActive")) {
        return false;
      }
      this.projectImage = "";
      const mapContainer = document.querySelector("#map-section");
      const infoBox = document.querySelector("#map-details-section");
      const closePop = document.querySelector(".close-modal");
      infoBox.setAttribute("style", "display:none;left:0px;top:0px");
      closePop.setAttribute("style", "left:auto;");
      const activeTree = document.querySelector(
        '[data-index="' + this.dataIndex + '"]'
      );
      mapContainer.setAttribute("style", "transform: scale(1)");
      // activeTree.classList.remove("treeActive");
      // mapContainer.classList.remove("details-open");
      jQuery(activeTree).removeClass("treeActive");
      jQuery(mapContainer).removeClass("details-open");
    },
  },
};



// WEBPACK FOOTER //
// ./src/quilted-northern/components/vx-interactive-map/vx-interactive-map.js